module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('span', {
    staticClass: "Serif_Bold _idGenCharOverride-1"
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Opening"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("F")]), _vm._v("at "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("akes blew into his "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("ce, cold wet kisses on his cheeks and eyelids. La"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" time there had been a winter like this, he’d been a wee boy and all he remembered was the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("n – sledging down the big hill, throwing snowballs in the playground, sliding across the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("ozen lake in the park. Now, it was a pain in the arse. Driving was a nightmare of slush and black ice. Walking was worse. He’d already wrecked his "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("vourite pair of shoes and every time he took his socks o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(", his toes were wrinkled pink"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" sultanas.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("But there were advantages. No one would ever know he’d been here. His "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("otprints would be erased within the hour. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere was nobody else on the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("reet. All the curtains were drawn tight to keep the night out and the heat in. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e children were indoors now, their every outdoor garment drying on kitchen pulleys and "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("eaming clothes horses a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v("er a day in the snow. Everybody else was huddled in "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("ont of the TV. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere had been enough snow this January "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the novelty to have worn o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(". Even the corporation bus he’d overtaken on the main drag had been empty, a gho"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" ship in the night. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e only people he’d passed had been a couple of "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("die")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("hards")]), _vm._v(" headed "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the pub. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere was an eerie "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("illness in this side "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("reet, though. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e snow su"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffo")]), _vm._v("cated the engine noise "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("w vehicles that had braved the blizzard. He "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("lt like the la"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" man"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("anding.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Head bowed again"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" the weather, he almo"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" missed his de"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ination. At the la"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" moment, he realised his mi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ake and wheeled abruptly into the lobby of the tenement close. He took a deep breath, brushing the snow "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om his"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" eyebrows.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("He climbed the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("airs, rehearsing what he’d been planning all day. He was "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("anding on the edge of the road to nowhere. Maybe it was late in the day to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("art thinking about protecting his "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("ture, but better late than never. And he’d "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("gured a way out. Maybe more"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" than one.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("It wouldn’t be easy. It might not be "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("raight"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rward. But he deserved better "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("than this.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("And tonight, there was going to be a "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("reckoning.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-611d5fd7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802159038-6.vue
// module id = 81
// module chunks = 0